import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
// import {SharedModule} from '../../../shared/shared.module';
import {TempFormsComponent} from './temp-forms.component';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {DatePipe} from '@angular/common';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ViewSequencePopupComponent} from './view-sequence-popup/view-sequence-popup.component';
// import {MatDialogModule, MatSelectModule, MatIconModule, MatMenuModule} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DeletePopupComponent} from './delete-popup/delete-popup.component';
import {DhwaniMaterialLibraryModule, SnackBarComponent} from 'dhwani-material-library';
import {SubmitConfirmationDialogComponent} from './../shared/submit-confirmation-dialog/submit-confirmation-dialog.component';
import { DownloadDataDialogComponent } from './download-data-dialog/download-data-dialog.component';
import { NgProgressModule } from 'ngx-progressbar';
import { ImportFormsComponent } from './import-forms/import-forms.component';
import { FormLinkingComponent } from '../shared/form-linking/form-linking.component';
import { GlobalNavigationHandlerComponent } from '../shared/global-navigation-handler/global-navigation-handler.component';
import { MaterialModule } from '../shared/material/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import {GojsAngularModule} from 'gojs-angular';
import { FileUploadComponent } from '../shared/file-upload/file-upload.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { AuthService } from '../form-translate/services/auth.service';
import { TranslationService } from '../form-translate/services/transation.service.service';
import { HttpModule } from '@angular/http';

export const TempFormsRotues: Routes = [
    {
        path: '',
        component: TempFormsComponent,
    }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(TempFormsRotues),
        // SharedModule,
        NgProgressModule,
      MatTooltipModule,
      MatDialogModule,
      MatRadioModule,
      DhwaniMaterialLibraryModule,
      FormsModule,
      ReactiveFormsModule,
      MatSlideToggleModule,
      MatStepperModule,
      MatSelectModule,
      GojsAngularModule,
      MatTabsModule,
      MatListModule,
      HttpModule,
      MatSnackBarModule
    ],

    declarations: [TempFormsComponent, DeletePopupComponent, SubmitConfirmationDialogComponent, DownloadDataDialogComponent, ImportFormsComponent,ViewSequencePopupComponent,FormLinkingComponent,GlobalNavigationHandlerComponent,FileUploadComponent],

    entryComponents: [DeletePopupComponent, SnackBarComponent, SubmitConfirmationDialogComponent, DownloadDataDialogComponent,FormLinkingComponent],
    providers: [DatePipe,AuthService,TranslationService]
})
export class TempFormsModule {
}
